import { Col, Row } from "reactstrap";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { CustomButton } from "../../widgets";
import { getVariable } from "./apiController";
import { update } from "lodash";
import { AutoComplete } from "antd";
import MonacoEditor from "./CodeEditor";
import CodeEditor from "./CodeEditor";
import MyEditor from "./CodeEditor";
import MonacoEditorWrapper from "./CodeEditor";

export default function FormulaEditor(props) {

    const initialValues = useMemo(() => (
        { formula: "" }
    ), []);

    const [values, fields, handleChange, { validateValues, reset, updateValue, updateError }] = useFieldItem({}, initialValues, { onValueChange });
    const [variableData, SetvariableData] = useState<any>([]);
    const [formulaId, SetformulaId] = useState<any>("");

    let ComputeOperators = [
        { value: ">", label: ">" },
        { value: "<", label: "<" },
        { value: "==", label: "==" },
        { value: ">=", label: ">=" },
        { value: "<=", label: "<=" },
        { value: "!=", label: "!=" },
        { value: "contains", label: "contains" },
        { value: "&&", label: "&&" },
        { value: "||", label: "||" },
        { value: "and", label: "and" },
        { value: "or", label: "or" },
        { value: "not", label: "not" },
        { value: "in", label: "in" },
        { value: "+", label: "+" },
        { value: "-", label: "-" },
        { value: "*", label: "*" },
        { value: "/", label: "/" },
        { value: "%", label: "%" },
        { value: "(", label: "(" },
        { value: ")", label: ")" },
        { value: "[", label: "[" },
        { value: "]", label: "]" },
        { value: "**1/2", label: "sqrt" },
        { value: "**2", label: "square" },
        { value: "**3", label: "cube" },
        { value: "**", label: "power" },
        { value: "reset", label: "reset" }
    ]

    ComputeOperators = [...ComputeOperators, ...props.variables]

    useEffect(() => {
        console.log(props)
    }, [variableData])

    /**
     * get variable data for selected variable 
     * @param id 
     */
    const getVariableData = async (id, key) => {
        try {
            let response = await getVariable(id);
            if (!key) {
                let fieldValues: any = [];
                response.field_value.map((item, i) => {
                    let Obj = {
                        label: item,
                        value: item
                    }
                    fieldValues.push(Obj)
                })
                console.log(fieldValues)
                SetvariableData(fieldValues)

                // variableList.filter(item => item.key == key).map((items) => {
                //     items.variablelist = fieldValues
                // })
            } else {
                SetvariableData(response.field_value)
                console.log(response.field_value)
            }
        } catch (e: any) {

        }
    }

    /**
   * handle on change values of form elements
   * @param name 
   * @param value 
   * @param values 
   * @param fieldValues 
   * @returns 
   */
    function onValueChange(name, value, values, fieldValues = null) {
        const resetValue = {}
        if (name == "variable") {
            getVariableData(value.value, "")
            SetformulaId(formulaId + ("$$" + value.value + "$$"))
            props.getFormulaData(formulaId + ("$$" + value.value + "$$"), values['formula'] + value.label);
            values.formula += value.label + " "
        }

        return [{
            ...values,
            ...resetValue,
            [name]: value,
        }]
    }

    /**
     * onsave clicked create the formaula and send data
     * also checking the length of code and tempcode created
     * trigger to getFormuladata function from props
     */
    const onSave = () => {
        let formulaData = "";
        let tempCodeData = tempCode;
        //check if length is not equal get the las element of code state
        if (code.length != tempCode.length) {
            let codes = code.split(" ");
            tempCodeData += codes[codes.length - 1]
        }
        //append $$ for create formula with id
        tempCodeData.split("$$").map(item => {
            let filterData = props.variables && props.variables.filter(items => items.label == item.trim());
            if (filterData.length > 0) {
                formulaData += "$$" + filterData[0].id + "$$ "
                console.log(filterData && filterData[0], formulaId)
            } else {
                formulaData += item + " "
                console.log(formulaId)
            }
        })
        SetformulaId(formulaData)
        console.log(code, tempCode)
        props.getFormulaData(formulaData, code, tempCode)
    }

    /**
     * on click operators add values to formula 
     */
    const updateFormula = (value) => {
        if (value != "reset") {
            let prevValue = values.formula + value + " ";
            SetformulaId(formulaId + value)
            props.getFormulaData(formulaId + value, values['formula'] + value)
            updateValue({ formula: prevValue })
            console.log(formulaId)
        } else {
            updateValue({ formula: "" })
            SetformulaId("")
        }
    }

    // let rep = props.values.newcode.replaceAll(" ", "  ")
    // console.log(rep.replaceAll(" ","$$"))
    const [code, setCode] = useState<string>(props.values.newcode || '');
    const [tempCode, settempCode] = useState<string>(props.values.newcode.replaceAll(" ", "$$$") || '');


    useEffect(() => {
        console.log(code,tempCode)
        const handleKeyDown = (event) => {
            // console.log(event.keyCode);
            if (event.code === "Backspace") {
                console.log("Spacebar pressed!");
            }
        };

        // Add event listener for keydown
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);


    /**
     * as user start writing formula update the state with update formual
     * @param newCode 
     * on new code add special character if special character
     * Add space before and after the special characters
     *
     */
    let data = props.values.newcode.replaceAll(" ", "$$$") || '';
    let i = 0;

    const handleCodeChange = (newCode: string, value: any) => {
        setCode(newCode);
        console.log(newCode)
        let valueCode = value.changes[0].text;
        let offset = value.changes[0].rangeOffset;
        console.log(valueCode)
        // console.log(newCode)
        if (valueCode.length != 0) {
            let specialCharExist = ComputeOperators.filter(items => items.value.trim() == valueCode.trim())
            if (specialCharExist.length > 0) {

                let previousIndex = data.lastIndexOf("$$", data.length - 1);
                console.log(previousIndex)

                let pd = data.slice((previousIndex > -1) ? previousIndex + 2 : 0, data.length);

                if (pd) {
                    console.log("pd",specialCharExist)
                    let matchs : any;
                    if(specialCharExist[0].label == specialCharExist[0].value){
                        matchs = specialCharExist.filter(items => items.value.toLowerCase().includes(pd.trim()))
                        console.log("Match",matchs)
                    }
                    else{
                        matchs = specialCharExist.filter(items => items.label.toLowerCase().includes(pd.trim()))
                        console.log("Match1",matchs)
                    }
                    

                    if (matchs.length > 0) {
                        if (previousIndex !== -1) {
                            data = data.slice(0, previousIndex + 2) +
                                data.slice(previousIndex + 2 + pd.length);

                        } else {
                            data = data.slice(pd.length);
                        }
                    } else if (pd != "$$") {
                        data += "$$";
                    }
                }


                data += valueCode.trim() + "$$";
                console.log(data)
            } else {
                if (valueCode == " " && valueCode.length != 0) {
                    if (data.slice(data.length - 2, data.length) !== "$$") {
                        data += "$$";
                    }
                } else {
                    // let newValue = newCode.split(" ");
                    // let lengthValue = newValue.length;

                    data += valueCode;
                }
            }

            // console.log(data)

            settempCode(data);
            //settempCode(tempCode+valueCode+"$$")
            let filterData = newCode.split(" ");
            let specialCharacter = ComputeOperators.filter(items => items.value == filterData[filterData.length - 1] || items.value == newCode[newCode.length - 1])
            if (specialCharacter.length > 0) {
                //check if already space exist after last character
                if (specialCharacter[0].value.length == 1 && newCode[newCode.length - 2] != " ") {
                    setCode(newCode.replace(/(?=.{1}$)/, ' ') + ' ');
                } else if (specialCharacter[0].value.length == 2 && newCode[newCode.length - 1] != " ") {
                    setCode(newCode.replace(/(?=.{1}$)/, ' ') + ' ');
                } else {
                    setCode(newCode + ' ');
                }
            } else {
                console.log(newCode)

                if (valueCode.length == 0) {
                    setCode(newCode);
                } else {
                    setCode(newCode);
                }
            }
        } else {

            // console.log(offset)
            // console.log(newCode.charAt(offset))
            let s = data.split("$$").length - 1
            const previousIndex = data.lastIndexOf("$$", offset + s);

            const nextIndex = data.indexOf("$$", offset + s);
            console.log(data.length)
            if (nextIndex !== -1) {
                if (previousIndex !== -1) {
                    data = data.slice(0, previousIndex) +
                        data.slice(nextIndex);

                } else {
                    data = data.slice(0, 0) +
                        data.slice(nextIndex);
                }
            } else if (previousIndex === data.length - 2) {
                let p = data.lastIndexOf("$$", previousIndex - 1);
                if (p !== -1) {
                    data = data.slice(0, p) +
                        data.slice(previousIndex);
                } else {
                    data = "";
                }
            } else {
                if (previousIndex !== -1) {
                    data = data.slice(0, data.length - 1);

                } else {
                    data = data.slice(0, data.length - 1);
                }

            }

        }
        let d2 = data.replaceAll("$$", " ");
        console.log("*******************",data);

        settempCode(data);
        setCode(d2);
        console.log(newCode);
        console.log(data)
    };

    return (
        <>
            <div className="mt-2 mr-2 ml-2 formula-list">
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", padding: "5px" }}>
                    <CloseOutlined style={{ color: "red" }} onClick={() => { props.removeComponent(props.values.key); props.getFormulaData("", "") }} />
                </div>
                <div className="expression">
                    <Row>
                        <Col md={12}>

                            <MonacoEditorWrapper
                                language="typescript"
                                suggest={ComputeOperators}
                                value={code}
                                onChange={handleCodeChange}
                            />

                        </Col>

                    </Row>
                    <CustomButton type="primary" className='save-button' text="Save" onClick={() => onSave()}></CustomButton>

                </div>
            </div>
        </>
    )
}